import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalDialog from './ModalDialog';
const ModalDialogWithImage = (props) => {
    const { t } = useTranslation();
    const [preloadedImg, setPreloadedImg] = useState();
    return (React.createElement(ModalDialog, Object.assign({ hideHeader: true, noPadding: true }, props),
        !preloadedImg && React.createElement("img", { className: "visually-hidden", "aria-hidden": "true", src: props.image, alt: props.alt || '', onLoad: () => setPreloadedImg(true) }),
        preloadedImg && (React.createElement("div", { className: "withimage" },
            React.createElement("div", { className: "withimage__body" },
                props.isBg ? (React.createElement("div", { className: "withimage__left", style: { backgroundImage: `url(${props.image})` } })) : (React.createElement("div", { className: "withimage__left" },
                    React.createElement("img", { src: props.image, alt: props.alt || '' }))),
                React.createElement("div", { className: "withimage__right" }, props.children))))));
};
export default ModalDialogWithImage;
